import React from 'react';
import { setDefaultOptions, loadModules } from 'esri-loader'
// import Graphic from '@arcgis/core/Graphic';
// import Point from '@arcgis/core/geometry/Point';
// import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';

export class Points extends React.Component<any, any> {
  componentDidMount() {
    this.plotPoints();
  }

  shouldComponentUpdate(nextProps: any) {
    if (nextProps.year !== this.props.year || nextProps.currentBarcode.BarCodeNumber !== this.props.currentBarcode.BarCodeNumber) {
      return true;
    } else {
      return false;
    }
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.year !== this.props.year) {
      this.props.view.graphics.removeAll();
      this.plotPoints();
    }
    if (prevProps.currentBarcode.BarCodeNumber !== this.props.currentBarcode.BarCodeNumber) {
      this.props.view.goTo({
        zoom: 20,
        heading: 180,
        center: [this.props.mapView.longitude, this.props.mapView.latitude],
      });
      this.props.view.popup.open({
        title: this.props.currentBarcode.BarCodeNumber,
        content: this.props.currentBarcode.description,
        location: [this.props.mapView.longitude, this.props.mapView.latitude],
      });
    }
  }

  plotPoints = () => {
    setDefaultOptions({ css: true });
    loadModules(['esri/Graphic', 'esri/geometry/Point', 'esri/symbols/SimpleMarkerSymbol'])
      .then(([Graphic, Point, SimpleMarkerSymbol]) => {
    if (this.props.points !== undefined) {
      this.props.points.forEach(async (item: any) => {
        if ((item.latitude !== null || item.longitude !== null) && (item.latitude !== 0 || item.longitude !== 0)) {
          // Settimeout will preventing blocking
          setTimeout(() => {
            const point = new Point({
              longitude: item.longitude,
              latitude: item.latitude,
            });

            const symbol = new SimpleMarkerSymbol({
              color: 'red',
              outline: {
                color: [0, 0, 0],
                width: 1,
              },
            });

            const scanDate = new Date(item.VerifyDate);
            const scanDateString =
              scanDate.getMonth() + '-' + scanDate.getDate() + '-' + scanDate.getFullYear() + ' ' + scanDate.getHours() + ':' + scanDate.getMinutes();

            const graphic = new Graphic({
              geometry: point,
              symbol: symbol,
              popupTemplate: {
                overwriteActions: false,
                title: '<b>' + item.BarCodeNumber + '</b>',
                content: '<p>' + item.description + '</p><p>Scanned by ' + item.UserId + ' on ' + scanDateString + '</p>',
              },
            });

            this.props.view.graphics.add(graphic);
          }, 0);
        }
      });
    }
    })
    .catch((err) => console.error(err));
  };

  render() {
    return null;
  }
}

export default Points;
